import { window } from "global";
import React, { useEffect } from "react";
import { usePageTitleAndDesc } from "lib/seo_helper";

const Careers = () => {
  const getPageTitleAndDesc = usePageTitleAndDesc();

  useEffect(() => {
    if (window) {
      window.scrollTo(0, 0);

      const script = document.createElement("script");
      script.src = "https://static.bigbrain.gg/js/jobscore.js";
      script.async = true;
      script.setAttribute("id", "job_score");
      document.body.appendChild(script);

      return () => {
        const script = document.getElementById("job_score");
        if (script) {
          document.body.removeChild(script);
          delete window._jobscore_loader;
        }
      };
    }
  }, []);

  return (
    <div className="text-page-container content-side-padding">
      {getPageTitleAndDesc("careers")}
      <div className="text-content-container">
        <div className="text-content">
          <h1> Careers at U.GG </h1>
          <p>
            U.GG is an incredibly fast growing startup founded to address information problems that millions of video game players
            around the world face on a daily basis. We are backed by a wide range of investors who truly believe in the space,
            including the Philadelphia 76ers innovation fund.
          </p>
          <p>Want to have immediate impact? Want to have ownership? Love the gaming space? If so, U.GG would be a perfect fit.</p>
          <img
            src="https://static.bigbrain.gg/assets/ugg/pages/career/team-chibis.png"
            alt="U.GG"
            style={{ marginTop: "100px" }}
          />
          <h2> Current Open Positions: </h2>
          <div
            className="jobscore-jobs"
            data-font-size="16px"
            data-sort-by="department,title,location"
            data-text-color="#3d79b5"
            data-link-text-color="lightblue"
            data-header-text-color="#FFFFFF"
            data-header-bg-color="#FFFFFF"
            data-group-by="department"
          >
            <div className="js-fallback" style={{ color: "#888" }}>
              <a style={{ color: "#888", textDecoration: "underline" }} href="https://careers.jobscore.com/jobs/ugg">
                U.GG jobs
              </a>
              powered by
              <a style={{ color: "#888" }} href="https://www.jobscore.com/">
                <img
                  style={{ padding: 0 }}
                  src="https://careers.jobscore.com/images/new/jobscore_logo_embed.png"
                  alt="Applicant Tracking, Social Recruiting and Software Hiring Solution - JobScore"
                ></img>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
